// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer-module__footer___2f7uz","footerRow":"footer-module__footerRow___21Tuc","wrap":"footer-module__wrap___1aU1E","footerWrapper":"footer-module__footerWrapper___1R3B0"};